var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mini-logo",on:{"click":_vm.clicked}},[(_vm.showSignPost)?_c('span',{key:_vm.path,staticClass:"mini-logo-image",style:({ backgroundImage: 'url(' + _vm.path + ')' })}):_c('span',{staticClass:"mini-logo-image fake"})])}
var staticRenderFns = []

export { render, staticRenderFns }